import { request } from "../utils/Request"
const BaseUrl = process.env.REACT_APP_STLLR_API_URL

export const fetchAllVideos = async (videoId = null, params = {}) => {
    let qs = videoId ? `?id=${videoId}` : ''

    const queryParams = []

    if (params.pageIndex !== undefined) queryParams.push(`pageIndex=${params.pageIndex}`)
    if (params.pageSize !== undefined) queryParams.push(`pageSize=${params.pageSize}`)
    if (params.search) queryParams.push(`search=${encodeURIComponent(JSON.stringify(params.search))}`)
    if (params.export) queryParams.push(`export=${encodeURIComponent(params.export)}`)

    if (queryParams.length > 0) {
        qs = videoId ? `${qs}&${queryParams.join('&')}` : `?${queryParams.join('&')}`
    }

    return request({
        url: `${BaseUrl}v1/admin/videos${qs}`
    }, true)
}

export const fetchFileOriginalUrl = async (fileId) => {
    return request({
        url: `${BaseUrl}v1/files/originalUrl/${fileId}`,
        method: "GET"
    }, true)
} 